export default "__VITE_PUBLIC_ASSET__8aadd9e1__"